import { render, staticRenderFns } from "./VehicleComingSoon.vue?vue&type=template&id=f9c7a954"
import script from "./VehicleComingSoon.vue?vue&type=script&lang=js"
export * from "./VehicleComingSoon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports